import {remote} from '../constants/environment';
import {IBalanceSheetItem} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {IBalanceSheetResponse} from '../interfaces/services';

import {customFetch as fetch, remoteCall} from '../utils/services';
import {IPortfolioFilter} from '../context/commons/interfaces';

export const getSalesmanBalanceSheet = async (
  token: string,
  filter?: IPortfolioFilter | null,
): Promise<IBalanceSheetResponse> => {
  const remoteURI = remote.getSalesmanBalanceSheetUri();
  const body = filter
    ? {
        body: JSON.stringify({
          payload: filter ?? null,
        }),
      }
    : {};
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: filter ? 'POST' : 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        ...body,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;
          const {balance} = data.payload;

          return {
            success,
            payload: balance as IBalanceSheetItem[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IBalanceSheetResponse;
};
